module.exports = __webpack_public_path__ + "img/act-of-emotion-process-2.0c9e06e2.jpg";